module.exports = __webpack_public_path__ + "img/gzhj_11.38f84c26.jpg";